import React from "react"
import { _toggleLoginDialog } from "../../actions/authentication"
/*Redux*/
import { useSelector, useDispatch } from "react-redux"
/*material*/
import { Dialog, DialogContent, DialogTitle, Box } from "@material-ui/core"
/*Components*/
import LoginDialogForm from "../LoginDialogForm/index"
/*Assets*/
import useStyles from "./styles"
import crewmamaLogo from "../../assets/images/crewmama_brand.png"
import { getCurrentHost } from "../../utils/getHost"

const LoginDialog = ({ history, props }) => {
  const classes = useStyles()
  const open = useSelector(state => state.authentication.loginDialogOpen)
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(_toggleLoginDialog(false))
  }

  return (
    <Dialog
      maxWidth="md"
      classes={{
        paper: classes.dialogPaper,
      }}
      open={open}
      onClose={handleClose}
    >
      <Box className={classes.wrapper}>
        <DialogTitle id="form-dialog-title" disableTypography>
          {/* <div className={classes.spacer} /> */}
          {getCurrentHost() === "crewmama" ? (
            <img
              src={crewmamaLogo}
              alt="CrewMama"
              style={{
                width: "44%",
                height: "20%",
                objectFit: "contain",
                objectPosition: "center",
                borderRadius: "20px",
              }}
            />
          ) : null}
        </DialogTitle>

        <DialogContent>
          <LoginDialogForm closeDialog={handleClose} history={history} />
        </DialogContent>
        <div className={classes.spacer} />
      </Box>
    </Dialog>
  )
}

export default LoginDialog
